<template>
  <div class="suppliers-customers-page">
    <div class="page-header">
      <h4>Customers</h4>
      <ol class="breadcrumbs">
        <li class="breadcrumb-item home">
          <router-link :to="{ name: 'SupplierDashboard'}">Dashboard</router-link>
        </li>
        <li class="breadcrumb-item active">
          <router-link :to="{ name: 'SupplierCustomers'}">View Customers</router-link>
        </li>
      </ol>
    </div>
    <div class="suppliers-customers-body">
      <tabs ref="suppliers-customer-view-table" cache-lifetime="0" :options="{useUrlFragment:false}">
        <tab name="Active" id="suppliers-customers-active" :class-name="'tab-content-table'">
          <div class="use-pagination-block-bottom">
            <b-table
                responsive
                hover
                :items="computedActiveCustomersPageSliced"
                :fields="customerFields"
                :no-local-sorting="true"
                :no-local-filtering="true"
                @sort-changed="ctx => onSortChanged(ctx, 'active')"
                @row-clicked="onActiveRowClicked"
            >
              <template v-slot:head()="data">
                <div v-if="!data.field.sortable">{{ data.label }}</div>
                <div v-if="data.field.sortable" class="table-sorting">{{ data.label }}<i></i></div>
              </template>
            </b-table>
          </div>
          <block-pagination
              :role="'Customers'"
              :count="activeCustomers.length"
              :countFiltered="computedActiveCustomersFull.length"
              :currentPage="getterCustomersAllCurrentPage"
              @changedCurrentPage="value => $store.commit('supplier/customers/supplierCustomersAllCurrentPage', value)"
              :perPage="gettersPerPage"
              @changedPerPage="value => $store.commit('supplier/customers/supplierCustomersPerPage', value)"
          >
          </block-pagination>
        </tab>
        <tab name="Cancelled" id="suppliers-customers-cancelled" :class-name="'tab-content-table'">
          <div class="use-pagination-block-bottom">
            <b-table
                responsive
                hover
                :items="computedCancelledCustomersPageSliced"
                :fields="customerFields"
                :no-local-sorting="true"
                :no-local-filtering="true"
                @sort-changed="ctx => onSortChanged(ctx, 'cancelled')"
                @row-clicked="onActiveRowClicked"
            >
              <template v-slot:head()="data">
                <div v-if="!data.field.sortable">{{ data.label }}</div>
                <div v-if="data.field.sortable" class="table-sorting">{{ data.label }}<i></i></div>
              </template>
            </b-table>
          </div>
          <block-pagination
              :role="'Customers'"
              :count="cancelledCustomers.length"
              :countFiltered="computedCancelledCustomersFull.length"
              :currentPage="getterCustomersPreferedCurrentPage"
              @changedCurrentPage="value => $store.commit('supplier/customers/supplierCustomersPreferedCurrentPage', value)"
              :perPage="gettersPerPage"
              @changedPerPage="value => $store.commit('supplier/customers/supplierCustomersPerPage', value)"
          >
          </block-pagination>
        </tab>
        <template slot="nav-item-right">
          <div class="tabs-nav-right-search">
            <b-form-input
                v-model="filter"
                type="text"
                class="search-input ml-3"
                placeholder="Search or Filter results"
                debounce="500">
            </b-form-input>
          </div>
          <div class="page-header-nav-options">
            <b-button
                class="btn-submit ml-1 text-center w-100 d-block d-lg-none btn-submit--invite"
                variant="primary">
              Invite Customer
            </b-button>
          </div>
        </template>
      </tabs>
    </div>

  </div>
</template>

<script>
import {mapGetters} from "vuex";
import BlockPagination from '../../../components/utility/block-pagination'
import _ from 'lodash'

export default {
  name: "customers",
  components: {
    BlockPagination
  },
  data() {
    return {
      filter: '',
      sortStateByTab: {
        active: { sortBy: 'name', sortDesc: false },
        cancelled: { sortBy: 'name', sortDesc: false },
      },
      customerFields: [
        {
          label: "Account Nbr",
          key: "number",
          sortable: true,
          tdClass: 'font-12 clickable rfq-number',
          thClass: 'font-13',
          class: 'font-inter font-inter--bold'
        },
        {
          label: "Customer Name",
          key: "name",
          sortable: true,
          tdClass: 'font-12 clickable ',
          thClass: 'font-13 font-inter--bold',
          class: 'font-inter'
        },
        {
          label: "Type",
          key: "type",
          sortable: true,
          tdClass: 'font-12 clickable ',
          thClass: 'font-13 font-inter--bold',
          class: 'font-inter',
          formatter: (value => {
            return this.getBusinessType(value)
          })
        },
        {
          label: "Customer Location",
          key: "customer_location",
          sortable: true,
          tdClass: 'font-12 clickable ',
          thClass: 'font-13 font-inter--bold',
          class: 'font-inter'
        },
        {
          label: "Phone",
          key: "phone",
          sortable: true,
          tdClass: 'font-12 clickable ',
          thClass: 'font-13 font-inter--bold',
          class: 'font-inter'
        },
        {
          label: "Email",
          key: "email",
          sortable: true,
          tdClass: 'font-12 clickable ',
          thClass: 'font-13 font-inter--bold',
          class: 'font-inter'
        },
      ]
    }
  },
  computed: {
    ...mapGetters({
      getActiveCustomers: 'supplier/customers/getActiveCustomers',
      getCancelledCustomers: 'supplier/customers/getCancelledCustomers',
      getAllCustomers: 'supplier/customers/getCustomers',
      gettersSearchIndexById: 'supplier/customers/getSearchIndexById',
      gettersPerPage: 'supplier/customers/getPerPage',
      gettersFilter: 'supplier/customers/getFilter',
      getterCustomersAllCurrentPage: 'supplier/customers/getCustomersAllCurrentPage',
      getterCustomersPreferedCurrentPage: 'supplier/customers/getCustomersPreferedCurrentPage',
    }),
    activeCustomers() {
      return _.map(this.getActiveCustomers, item => {
        item.customer_location = '';
        if (item.postcode) item.customer_location += item.postcode;
        if (item.customer_location) item.customer_location += ', ';
        if (item.suburb) item.customer_location += item.suburb;
        if (item.customer_location) item.customer_location += ', ';
        if (item.state) item.customer_location += item.state;
        if (_.isEmpty(item.type)) item.type = "Repair";
        return item;
      });
    },
    cancelledCustomers() {
      return _.map(this.getCancelledCustomers, item => {
        item.customer_location = '';
        if (item.postcode) item.customer_location += item.postcode;
        if (item.customer_location) item.customer_location += ', ';
        if (item.suburb) item.customer_location += item.suburb;
        if (item.customer_location) item.customer_location += ', ';
        if (item.state) item.customer_location += item.state;
        if (_.isEmpty(item.type)) item.type = "Repair";
        return item;
      });
    },
    computedActiveCustomersFull() {
      let items = this.activeCustomers.slice()
      items = this._applyTextFilter(items)
      items = this._applySort(items, 'active')
      return items
    },
    computedActiveCustomersPageSliced() {
      return this._pageSlice(this.computedActiveCustomersFull, this.getterCustomersAllCurrentPage, this.gettersPerPage)
    },
    computedCancelledCustomersFull() {
      let items = this.cancelledCustomers.slice()
      items = this._applyTextFilter(items)
      items = this._applySort(items, 'cancelled')
      return items
    },
    computedCancelledCustomersPageSliced() {
      return this._pageSlice(this.computedCancelledCustomersFull, this.getterCustomersPreferedCurrentPage, this.gettersPerPage)
    },
  },
  mounted() {
    if (!this.filter) {
      this.filter = this.gettersFilter;
    }
  },
  watch: {
    filter(val) {
      this.$store.commit('supplier/customers/supplierCustomersFilter', val)
    }
  },
  methods: {
    onSortChanged(ctx, tabKey) {
      if (!ctx || !tabKey) return
      if (!this.sortStateByTab || !this.sortStateByTab[tabKey]) return

      this.$set(this.sortStateByTab, tabKey, {
        sortBy: ctx.sortBy,
        sortDesc: !!ctx.sortDesc,
      })
    },
    _getSortValue(item, sortBy) {
      if (!item) return ''
      const v = item[sortBy]
      if (typeof v === 'string') return _.toLower(v)
      return v
    },
    _applySort(items, tabKey) {
      const list = Array.isArray(items) ? items : []
      const sortState = this.sortStateByTab?.[tabKey]
      const sortBy = sortState?.sortBy
      const sortDesc = !!sortState?.sortDesc
      if (!sortBy) return list

      return _.orderBy(
        list,
        [(itm) => this._getSortValue(itm, sortBy)],
        [sortDesc ? 'desc' : 'asc']
      )
    },
    _applyTextFilter(items) {
      const list = Array.isArray(items) ? items : []
      const q = _.trim(_.toLower(this.filter || ''))
      if (!q) return list

      const idx = this.gettersSearchIndexById || {}
      return _.filter(list, (c) => {
        if (!c || c.id == null) return false
        const s = idx[String(c.id)]
        if (!s) return false
        return _.includes(s, q)
      })
    },
    _pageSlice(items, currentPage, perPage) {
      const list = Array.isArray(items) ? items : []
      const pp = Number(perPage) || 0
      const cp = Number(currentPage) || 1
      if (pp <= 0) return list
      const start = (cp - 1) * pp
      if (start < 0) return list
      return list.slice(start, start + pp)
    },
    getBusinessType (value) {
      if (value === 'CarRepairer') {
        return 'Auto Body Repairer'
      } else if (value === 'BikeRepairer') {
        return 'Motorbike Repairer'
      } else if (value === 'TruckRepairer') {
        return 'Truck Repairer'
      }
      return value
    },
    onActiveRowClicked(row) {
      this.$router.push({name: 'SupplierCustomerView', params: {'customer_id': row.id}});
    },
  }
};
</script>

<style scoped>
@media screen and (max-width: 768px) {
  .suppliers-customers-body .page-header-nav-options {
    position: absolute;
    right: 15px;
    top: 147px;
  }
}
</style>
